const api_base_path = process.env.REACT_APP_API_BASE_PATH;
export const globals = {
  api_base_path,
  api_url: `${api_base_path}/api`,
};